/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosDialogHeader from "../../../../../components/Dialogs/ArgosDialogHeader";
import React from "react";
import ReportView from "./ReportView";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import {IconButton} from "@mui/material";
import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";

const ReportViewWrapper = React.memo((props: any) => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', height: "100%"}}>
      <div style={{}}>
        <ArgosDialogHeader>
          <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
            <Typography sx={{color: 'white', fontSize: 14, textAlign: 'left'}}>
              Report View
            </Typography>
            <IconButton onClick={() => null} sx={{color: 'white', padding: 0, fontSize: 'small'}}>
              <CloseIcon/>
            </IconButton>
          </ArgosFlexbox>
        </ArgosDialogHeader>
      </div>

      <div style={{flex: 1, overflow: 'auto', padding: 0}}>
        <ReportView/>
      </div>
    </div>
  )
})

export default ReportViewWrapper
